import { render, staticRenderFns } from "./interWarehouseList.vue?vue&type=template&id=defabcc4&scoped=true"
import script from "./interWarehouseList.vue?vue&type=script&lang=js"
export * from "./interWarehouseList.vue?vue&type=script&lang=js"
import style0 from "./interWarehouseList.vue?vue&type=style&index=0&id=defabcc4&prod&style=true&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defabcc4",
  null
  
)

export default component.exports